import type React from 'react';

import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { SupporterVideo } from '../../shared/types';

export const PetitionVideoItemHeader: React.FC<{ video: SupporterVideo }> = ({ video }) => {
	const { user, createdAtRelativeLocalized: localizedTime } = video;
	const author = user?.shortDisplayName;

	return (
		<Flex sx={{ justifyContent: 'space-between', flexDirection: 'row' }} mb={16}>
			<Flex sx={{ alignItems: 'center', gap: '8px', flexDirection: 'row' }}>
				<Avatar alt="user avatar" />
				<Text fontWeight="bold">{author}</Text>
			</Flex>
			<Flex sx={{ alignItems: 'center' }}>
				<Text sx={{ textAlign: 'right' }}> {localizedTime}</Text>
			</Flex>
		</Flex>
	);
};
